/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.controller('dialog_addEventCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
    
        $scope.gui = {};
        $scope.gui.okButtonDisabled = true;
        $scope.event = {};
        $scope.datetTimePattern = //;
        
        $scope.hasValue = function(model){
            return model != undefined && model != "";
        }
        $scope.formChanged = function(){
            if($scope.hasValue($scope.event.Veranstaltungsname) && $scope.hasValue($scope.event.Startzeit) && $scope.hasValue($scope.event.Endzeit) && $scope.hasValue($scope.event.Veranstaltungsort)){
                $scope.gui.okButtonDisabled = false;
            }
        }
        
        $scope.createEvent = function ()
        {
            var newEvent = {
                name: $scope.event.Veranstaltungsname,
                location: $scope.event.Veranstaltungsort,
                start: moment($scope.event.Startzeit).format("YYYY-MM-DD hh:mm:ss"),
                end: moment($scope.event.Endzeit).format("YYYY-MM-DD hh:mm:ss")
            }
            
             NetworkService.callOperation("addevent", newEvent, function(response){
                 if(response.isSuccessfull()){
                     AtlasNotification.info("Veranstaltung wurde erfolgreich hinzugefügt.")
                 }
             })
        }
    }])